/*
 * AQS — lookbook scroll parallax. The big spread images drift at a different
 * rate than the page as you scroll, for a premium magazine depth. GPU
 * transforms, rAF-throttled, JS-gated (no-JS/reduced-motion = normal images).
 */
(function () {
  if (window.__aqsLbParallax) return;
  window.__aqsLbParallax = true;

  if (
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  )
    return;

  function init() {
    var section = document.querySelector('.aqs-lbp');
    if (!section) return;

    var items = [];
    section.querySelectorAll('[data-aqs-parallax]').forEach(function (el) {
      var img = el.querySelector('img');
      if (img) items.push({ el: el, img: img });
    });
    if (!items.length) return;

    section.classList.add('js-parallax');

    var raf = null;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (o) {
        var r = o.el.getBoundingClientRect();
        if (r.bottom < -120 || r.top > vh + 120) return; // off-screen
        var center = r.top + r.height / 2;
        var prog = (center - vh / 2) / (vh / 2 + r.height / 2); // ~ -1..1
        if (prog > 1) prog = 1;
        if (prog < -1) prog = -1;
        o.img.style.setProperty('--py', (prog * 42).toFixed(1) + 'px');
      });
      raf = null;
    }
    function onScroll() {
      if (!raf) raf = requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
